module.exports = __webpack_public_path__ + "images/video-icon.png";